<nav class="navbar app-top-navbar navbar-expand-lg px-3 px-lg-4">
    <div class="container-fluid">
        <a class="navbar-brand" routerLink="/home" aria-label="RYNO Home">
            <img src="assets/images/logo.png" class="logo-sm" alt="RYNO logo" />
        </a>

        <div class="mobile-header-actions">
            <app-notification-bell class="mobile-bell d-lg-none"></app-notification-bell>
            <button class="mobile-theme-toggle" type="button" aria-label="Toggle theme" (click)="onMobileThemeToggle()">
                <i class="fas fa-sun"></i>
            </button>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation" (click)="onMobileSidebarToggle()">
                <span class="navbar-toggler-icon"></span>
            </button>
        </div>

        <div class="collapse navbar-collapse app-navbar-collapse" id="navbarContent">
            <ul class="navbar-nav app-nav-links mb-2 mb-lg-0 d-flex align-items-lg-center">
                <li class="nav-item">
                    <a class="nav-link" href="/home" [class.active]="isHomeActive()" (click)="goToHome($event)">
                        Home
                    </a>
                </li>
                <li class="nav-item" *ngIf="subscription?.basic_search_permission !== false">
                    <a class="nav-link" routerLink="/basic-search" [class.active]="isActive('basic-search')">
                        Basic Search
                    </a>
                </li>
                <li class="nav-item" *ngIf="subscription?.face_search_permission || subscription?.osint_search_permission">
                    <a class="nav-link" href="/osint-number-search" [class.active]="isOsintSearchActive()" (click)="goToOsintSearch($event)">
                        Osint Search
                    </a>
                </li>
                <li class="nav-item" *ngIf="subscription?.link_analysis_permission !== false">
                    <a class="nav-link" routerLink="/link-analysis" [class.active]="isActive('link-analysis')">
                        Link Analysis
                    </a>
                </li>
                <li class="nav-item" *ngIf="subscription?.face_search_permission">
                    <a class="nav-link" routerLink="/osint-image-search" [class.active]="isActive('osint-image-search')">
                        Face Search
                    </a>
                </li>
                <li class="nav-item" *ngIf="subscription?.leak_search_permission">
                    <a class="nav-link" routerLink="/leak-number-search" [class.active]="isActive('leak')">
                        Leak Search
                    </a>
                </li>
                <li class="nav-item" *ngIf="subscription?.link_shortener_permission">
                    <a class="nav-link" routerLink="/generate-tracking-link" [class.active]="isActive('generate-tracking-link')">
                        FasTrak
                    </a>
                </li>
            </ul>

            <div class="navbar-actions">
                <div class="apps-launcher">
                    <button
                        class="navbar-icon-btn"
                        type="button"
                        aria-label="Apps menu"
                        [attr.aria-expanded]="isAppsOpen"
                        aria-haspopup="true"
                        [class.active]="isAppsOpen"
                        (click)="toggleAppsMenu($event)"
                    >
                        <svg class="apps-launcher-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                            <circle cx="5" cy="5" r="2" />
                            <circle cx="12" cy="5" r="2" />
                            <circle cx="19" cy="5" r="2" />
                            <circle cx="5" cy="12" r="2" />
                            <circle cx="12" cy="12" r="2" />
                            <circle cx="19" cy="12" r="2" />
                            <circle cx="5" cy="19" r="2" />
                            <circle cx="12" cy="19" r="2" />
                            <circle cx="19" cy="19" r="2" />
                        </svg>
                    </button>

                    <div class="apps-launcher-panel" *ngIf="isAppsOpen" role="menu" aria-label="Apps">
                        <div class="apps-launcher-header">
                            <span class="apps-launcher-title">More searches</span>
                        </div>
                        <div class="apps-launcher-grid">
                            <a
                                class="apps-launcher-item"
                                *ngFor="let app of visibleApps"
                                [routerLink]="app.route"
                                routerLinkActive="is-active"
                                role="menuitem"
                                [attr.title]="app.label.replace('\n', ' ')"
                                [attr.aria-label]="app.label.replace('\n', ' ')"
                                (click)="onAppNavigate()"
                            >
                                <span class="apps-launcher-item-icon" [ngClass]="app.shade">
                                    <img [src]="app.image" [alt]="app.label.replace('\n', ' ')" />
                                </span>
                                <span class="apps-launcher-item-label">{{ app.label }}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <app-notification-bell class="d-none d-lg-inline-flex"></app-notification-bell>
                <a class="navbar-icon-btn" routerLink="/user-account" routerLinkActive="active" aria-label="My Account">
                    <i class="bi bi-person-circle"></i>
                </a>
            </div>
        </div>
    </div>
</nav>
